<script setup>
import {computed, ref} from 'vue';
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import RejectionConfirmationModal from "@/components/approval-center/modals/RejectionConfirmationModal.vue";
import moment from "moment";
import useUser from "@/composables/useUser";

const props = defineProps({
  approval: {
    type: Object,
    required: true,
  },
  category: {
    type: String,
    required: true,
  }
});

const {isAdmin} = useUser();

const formattedDate = computed(() => {
  const date = moment(props.approval.auto_approve_at);
  return date.format('DD/MM/YYYY');
});

const daysUntil = computed(() => {
  const targetDate = moment(props.approval.auto_approve_at).startOf('day');

  const today = moment().startOf('day');

  return targetDate.diff(today, 'days');
});

const toggleConfirmationModal = () => {
  showConfirmationModal.value = !showConfirmationModal.value;
}

const showConfirmationModal = ref(false);
</script>

<template>
  <div class="tw-text-caution-700 tw-text-xs tw-flex tw-gap-4 tw-items-center">
    <DefaultButton
      v-if="isAdmin"
      variant="danger"
      size="small"
      @click="toggleConfirmationModal"
    >
      Reject
    </DefaultButton>

    <span>
      This will be auto-approved in {{ daysUntil }} days ({{ formattedDate }}).
    </span>

    <RejectionConfirmationModal
      v-if="showConfirmationModal"
      :approval-id="approval.id"
      :category="category"
      @close="toggleConfirmationModal"
    />
  </div>
</template>
